import { Edit, Delete, Add } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useState, useEffect, SetStateAction } from "react";

const API_BASE_URL = "https://localhost:44354/api/admin/subcategories";
const API_BASE_URL1 = "https://localhost:44354/api/admin";
type CategoryEntry = {
  [x: string]: any;
  id: number;
  name: string;
  categoryname: string;
  icon: string | string[];
};
interface Catgry {
  id: number;
  name: string;
}

const Categorysub = () => {
  const [dataList, setDataList] = useState<CategoryEntry[]>([]);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [categories, setCategories] = useState<Catgry[]>([]);
  const [formData, setFormData] = useState<CategoryEntry>({
    id: 0,
    name: "",
    categoryname: "",
    icon: [],
  });
  useEffect(() => {
    const savedData = localStorage.getItem("adminDataList");
    if (savedData) {
      const parsedData: CategoryEntry[] = JSON.parse(savedData);
      setDataList(parsedData);

      if (!savedData || parsedData.length === 0) {
        setEditingIndex(null);
      }
    }
  }, []);

  //Fetch Categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_BASE_URL1}/categories`);
        if (!response.ok) throw new Error("Failed to fetch categories");
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories", error);
      }
    };
    //call the fetch functions
    fetchCategories();
  }, []);
  const fetchData = async () => {
    try {
      const response = await fetch(API_BASE_URL);
      if (!response.ok) throw new Error("Failed to fetch data");
      const data: CategoryEntry[] = await response.json();
      setDataList(data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const resetForm = () => {
    //Reset Form
    setFormData({
      id: dataList.length + 1, //Increment ID
      name: "",
      categoryname: "",
      icon: [],
    });
    setEditingIndex(null);
  };
  //Add New Record
  const handleAdd = () => {
    setEditingIndex(null);
    setShowForm(true);
    // resetForm();// Clear form and show it
    setFormData({
      id: 0,
      name: "",
      categoryname: "",
      icon: [],
    });
  };
  //Handle input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      lastUpdated: new Date().toISOString(),
    });
  };
  //Handle file selection
  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "image"
  ) => {
    if (e.target.files) {
      const filesArray = Array.from(e.target.files);
      if (type === "image") {
        setSelectedImages(filesArray);
      }
    }
  };
  //handle Image Upload
  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    handleFileChange(e, "image");
    if (selectedImages.length === 0) return;
    const formData = new FormData();
    selectedImages.forEach((file) => formData.append("icon", file));
    try {
      const response = await fetch(`${API_BASE_URL})/upload`, {
        method: "POST",
        body: formData,
      });
      if (!response.ok) throw new Error("Failed to upload images");
      fetchData();
      setSelectedImages([]);
    } catch (error) {
      console.error("Error uploading images", error);
    }
  };

  const handleSave = async () => {
    if (!formData.name.trim()) {
      alert("Name is required!");
      return;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("id", editingIndex?.toString() ?? "0");
    formDataToSend.append("name", formData.name);
    formDataToSend.append("categoryname", formData.categoryname);
    // Append selectedImages
    selectedImages.forEach((image) => {
      formDataToSend.append("icon", image);
    });
    // Append updated icon as files
    if (Array.isArray(formData.icon)) {
      for (const url of formData.icon) {
        const response = await fetch(url);
        const blob = await response.blob();
        const fileName = url.split("/").pop() || "default.jpg"; // Provide a default name if undefined
        const file = new File([blob], fileName, { type: blob.type });
        formDataToSend.append("icon", file);
      }
    }

    const url =
      editingIndex !== null
        ? `${API_BASE_URL}/${formData.id}`
        : `${API_BASE_URL}/upload`;
    try {
      const response = await fetch(url, {
        method: editingIndex !== null ? "PUT" : "POST",
        body: formDataToSend,
      });
      if (!response.ok) throw new Error("Failed to save data");
      alert("Data saved successfully");
      fetchData();
      resetForm();
      (document.getElementById("imageUpload") as HTMLInputElement).value = "";
      setSelectedImages([]);
      setEditingIndex(null);
      setShowForm(false);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };
  useEffect(() => {
    if (editingIndex !== null) {
      const selectedEntry = dataList.find((item) => item.id === editingIndex);
      if (selectedEntry) {
        const icon =
          typeof selectedEntry.icon === "string"
            ? selectedEntry.icon.split(",")
            : Array.isArray(selectedEntry.icon)
            ? selectedEntry.icon
            : [];

        setFormData({
          ...selectedEntry,
          icon,
        });
      }
    }
  }, [editingIndex, dataList]);
  const handleEdit = (id: number) => {
    const selectedEntry = dataList.find((item) => item.id === id);
    if (!selectedEntry) {
      console.error("No entry found with id:", id);
      return;
    }
    setFormData({
      ...selectedEntry,
      icon:
        typeof selectedEntry.icon === "string"
          ? selectedEntry.icon.split(",")
          : Array.isArray(selectedEntry.icon)
          ? selectedEntry.icon
          : [],
    });
    setEditingIndex(selectedEntry.id);
    setShowForm(true);
  };

  //Delete a record
  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure want to delete this entry?")) return;
    try {
      const response = await fetch(`${API_BASE_URL}/${id}`, {
        method: "DELETE",
      });

      if (!response.ok) throw new Error("Failed to delete");

      fetchData();
      if (editingIndex !== null && dataList[editingIndex]?.id === id) {
        setEditingIndex(null);
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };
  // Group data by categoryname
  const groupedData = dataList.reduce((acc, item) => {
    if (!acc[item.categoryname]) {
      acc[item.categoryname] = [];
    }
    acc[item.categoryname].push(item);
    return acc;
  }, {} as { [key: string]: CategoryEntry[] });
  return (
    <Box
      sx={{
        backgroundColor: "#f4f4f4",
        minHeight: "100vh",
        overflow: "hidden",
        padding: 3,
      }}
    >
      {/* <Typography variant="h5" align="center" sx={{mb:2,fontWeight:"bold"}}>Sub Category</Typography> */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 3 }}>
        <TableContainer
          component={Paper}
          sx={{
            padding: 2,
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          {Object.keys(groupedData).length > 0 ? (
            Object.keys(groupedData).map((categoryname) => (
              <Box key={categoryname} sx={{ marginBottom: 2 }}>
                <Typography
                  sx={{ marginBottom: 1, fontSize: "15px", fontWeight: "Bold" }}
                >
                  {categoryname}
                </Typography>
                <Table size="medium">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{ position: "absolute", top: 65, right: 80 }}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          size="small"
                          onClick={handleAdd}
                        >
                          <Add fontSize="small" />
                        </Button>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <b>Category Name</b>
                      </TableCell>
                      <TableCell>
                        <b>SubCategory Name</b>
                      </TableCell>
                      <TableCell>
                        <b>Icon</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groupedData[categoryname].map((item, index) => (
                      <TableRow key={index}>
                        {/* {item.id &&<TableCell>{item.id }</TableCell>} */}
                        {item.categoryname && (
                          <TableCell>{item.categoryname || "\u00A0"}</TableCell>
                        )}
                        {item.name && (
                          <TableCell>{item.name || "\u00A0"}</TableCell>
                        )}
                        <TableCell>
                          {typeof item.icon === "string" ? (
                            item.icon.split(",").map((img, index) => (
                              <div key={index}>
                                <img
                                  key={index}
                                  src={`https://localhost:44354${img}`}
                                  alt="Uploaded"
                                  width="50"
                                  height="50"
                                />
                              </div>
                            ))
                          ) : (
                            <Typography>No icon</Typography>
                          )}
                        </TableCell>
                        <TableCell align="right">
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() => {
                              handleEdit(item.id);
                            }}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton
                            color="error"
                            size="small"
                            onClick={() => handleDelete(item.id)}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ))
          ) : (
            <Box textAlign="center" mt={2}>
              <Typography align="center" sx={{ mt: 2 }}>
                No records found.
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                onClick={handleAdd}
              >
                <Add fontSize="small" />
              </Button>
            </Box>
          )}
        </TableContainer>
        {showForm && (
          <Paper
            elevation={3}
            sx={{ padding: 3, width: "70%", borderRadius: 2 }}
          >
            <Stack spacing={1}>
              <input type="hidden" name="id" value={formData.id} />
              <TextField
                select
                label="Category"
                size="small"
                name="category"
                value={formData.categoryname}
                onChange={(e) =>
                  setFormData({ ...formData, categoryname: e.target.value })
                }
                fullWidth
              >
                {categories.map((cat: Catgry) => (
                  <MenuItem key={cat.id} value={cat.name}>
                    {cat.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                label="Sub Category"
                name="name"
                value={formData.name}
                onChange={handleChange}
                fullWidth
                multiline
                rows={1}
              />
              <Button variant="contained" component="label" color="primary">
                Choose Icon
                <input
                  id="imageUpload"
                  type="file"
                  accept="image/jpeg,image/png*"
                  multiple
                  onChange={handleImageUpload}
                />
              </Button>
              <Stack spacing={1}>
                <div>
                  <button hidden onClick={() => handleEdit(0)}>
                    Edit Entry
                  </button>{" "}
                  {/* Replace 0 with the actual index */}
                </div>
              </Stack>
              <Stack direction="row" spacing={2} justifyContent="space-between">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleSave}
                >
                  {editingIndex !== null ? "Update" : "Save"}{" "}
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => setShowForm(false)}
                >
                  Cancel{" "}
                </Button>
              </Stack>
            </Stack>
          </Paper>
        )}
      </Box>
    </Box>
  );
};

export default Categorysub;
